export const env = (process.env.NEXT_PUBLIC_DEPLOY_ENV || 'dev') as
    | 'dev'
    | 'uat'
    | 'prod';
